import request from '@/axios/index';
export function formConfig({ method, reqInfo, id }) {
	return request({
		url: id ? `/formConfig/${id}` : `/formConfig`,
		method,
		[method === 'get' ? 'params' : 'data']: reqInfo,
	});
}
// 列表设置
// 列表设置（字段）
export function fieldsConfig({ method, reqInfo, id }) {
	return request({
		url: id ? `/fieldsConfig/${id}` : `/fieldsConfig`,
		method,
		[method === 'get' ? 'params' : 'data']: reqInfo,
	});
}
// 列表设置（字段）批量编辑及顺序重置
export function fieldsConfigUpdateBatch(data) {
	return request({
		url: `/fieldsConfig/update/batch`,
		method: 'post',
		data
	});
}
// 列表设置（字段）批量删除
export function fieldsConfigBatchDelete(data) {
	return request({
		url: `/fieldsConfig/batch/delete`,
		method: 'post',
		data
	});
}
// 列表设置（表单）批量保存
export function fieldsConfigBatch(data) {
  return request({
    url: `/fieldsConfig/batch`,
    method: 'put',
    data
  });
}
// 列表设置（表单）
export function itemsConfig({ method, reqInfo, id }) {
	return request({
		url: id ? `/itemsConfig/${id}` : `/itemsConfig`,
		method,
		[method === 'get' ? 'params' : 'data']: reqInfo,
	});
}
// 列表设置（表单）批量编辑及顺序重置
export function itemsConfigUpdateBatch(data) {
	return request({
		url: `/itemsConfig/update/batch`,
		method: 'post',
		data
	});
}
// 列表设置（表单）批量删除
export function itemsConfigBatchDelete(data) {
	return request({
		url: `/itemsConfig/batch/delete`,
		method: 'post',
		data
	});
}
// 列表设置（表单）批量保存
export function itemsConfigBatch(data) {
  return request({
    url: `/itemsConfig/batch`,
    method: 'put',
    data
  });
}
// sheet页
export function sheetsConfig({ method, reqInfo, id }) {
	return request({
		url: id ? `/sheetsConfig/${id}` : `/sheetsConfig`,
		method,
		[method === 'get' ? 'params' : 'data']: reqInfo,
	});
}
// sheet页
export function sheetsConfigrequest(params) {
	let count = Math.ceil(Math.random() * 10)
	return request({
		url: "/sheetsConfig?" + count,
		method: "get",
		params
	});
}
// sheet页批量编辑
export function sheetsConfigUpdateBatch(data) {
	return request({
		url: `/sheetsConfig/batchUpdate`,
		method: 'post',
		data
	});
}
// sheetc页面批量删除
export function sheetConfigDeleteBatch(data) {
	return request({
		url: `/sheetsConfig/batchDelete`,
		method: 'post',
		data
	})
}
//调取
export function fetchConfig({ method, reqInfo, id }) {
	return request({
		url: id ? `/fetchConfig/${id}` : `/fetchConfig`,
		method,
		[method === 'get' ? 'params' : 'data']: reqInfo,
	});
}
//调取字段设置列表
export function fetchFieldsConfig({ method, reqInfo, id }) {
	return request({
		url: id ? `/fetchFieldsConfig/${id}` : `/fetchFieldsConfig`,
		method,
		[method === 'get' ? 'params' : 'data']: reqInfo,
	});
}
// 调取设置（字段设置）批量编辑及顺序重置
export function fetchFieldsConfigUpdateBatch(data) {
	return request({
		url: `/fetchFieldsConfig/update/batch`,
		method: 'post',
		data
	});
}
// 调取设置（字段设置）批量删除
export function fetchFieldsConfigBatchDelete(data) {
	return request({
		url: `/fetchFieldsConfig/batch/delete`,
		method: 'post',
		data
	});
}
//数据字典
export function dataDic({ method, reqInfo, id }) {
	return request({
		url: id ? `/dataDic/${id}` : `/dataDic`,
		method,
		[method === 'get' ? 'params' : 'data']: reqInfo,
	});
}
//数据字典项
export function dictItem({ method, reqInfo, id }) {
	return request({
		url: id ? `/dataItem/${id}` : `/dataItem`,
		method,
		[method === 'get' ? 'params' : 'data']: reqInfo,
	});
}
// 获取数据权限
export function roleNamefunc(params) {
	return request({
		url: '/dataDic/role_perms',
		methods: 'get',
		params
	})
}
// 清除缓存
export function clearCache() {
	let timestamp = new Date().getTime();
	return request({
		url: `custom/clearCache?time=${timestamp}`,
		method: 'get',
	});
}

// 复制模块
export function copyModule(data) {
	return request({
		url: '/formConfig/copyModules',
		method: 'post',
		data,
		timeout: 1000 * 60 * 10
	})
}

//初始化模块语言包
export function initLanguage() {
	return request({
		url: '/formConfig/initLanguage',
		method: 'post',
		timeout: 1000 * 60 * 10
	})
}

// 表单计算公式 保存
export function submitFormulaInfo(data, id) {
	return request({
		url: '/form-calculate-formula',
		method: 'post',
		data,
    params: { formId: id }
	})
}

// 表单计算公式 获取字段数据
export function getFormulaById(id) {
	return request({
		url: `/form-calculate-formula/form/${id}`,
		method: 'get'
	})
}
// 计算表达式 删除
export function deleteFormulaById(id) {
	return request({
		url: `/form-calculate-formula/${id}`,
		method: 'delete'
	})
}

// 表单计算公式  获取字段数据
export function getFormulaByFieldId(data) {
	return request({
		url: `/form-calculate-formula/${data.type}/${data.fieldId}`,
		method: 'get'
	})
}

// 表单计算公式  列表
export function getFormulaList() {
	return request({
		url: '/form-calculate-formula',
		method: 'get',
	})
}

// 获取	登录背景图  免登录
export function getLoginBackgroundPass() {
	return request({
		url: '/custom-theme/background/pass',
		method: 'get'
	})
}

// 获取	登录背景图
export function getLoginBackground() {
	return request({
		url: '/custom-theme/background',
		method: 'get'
	})
}

// 获取logo
export function getLogoImg() {
	return request({
		url: '/custom-theme/logo',
		method: 'get'
	})
}

// 上传 登录背景图
export function uploadLoginBackground(data) {
	return request({
		url: '/custom-theme/background',
		method: 'post',
		data: data
	})
}

// 上传 logo图
export function uploadLogoImg(data) {
	return request({
		url: '/custom-theme/logo',
		method: 'post',
		data: data
	})
}

//关于
export function about() {
	return request({
		url: '/help/about',
		method: 'get'
	})
}

// 列表批量设置字段
export function formUploadShowName(data) {
	return request({
		url: '/formConfig/update/show-name',
		method: 'post',
		data: data
	})
}
// 调取批量设置字段
export function fetchUploadShowName(data) {
	return request({
		url: '/fetchConfig/update/show-name',
		method: 'post',
		data: data
	})
}

// 自动转公海配置
export function saveCustctrlConfig(data) {
	return request({
		url: '/custctrl_config/save',
		method: 'post',
		data: data
	})
}

// 获取配置
export function getCustCtrlConfig() {
	return request({
		url: '/custctrl_config/list',
		method: 'get',
	})
}

//查看定时推送配置
export function getTimerPushConfigList(params) {
	return request({
		url: '/timerPushConfig/list',
		method: 'get',
		params,
	})
}

// 新增保存
export function saveTimePushConfig(info) {
	return request({
		url: '/timerPushConfig/save',
		method: 'post',
		data: info
	})
}

// 删除定时推送配置
export function deleteTimePushConfig(ids) {
	return request({
		url: '/timerPushConfig/delete',
		method: 'post',
		data: ids
	})
}

// 通过id查询详情
export function getTimePushConfigById(params) {
	return request({
		url: '/timerPushConfig/detail',
		method: 'get',
		params: params
	})
}

// 查询类型
export function searchTimePushType() {
	return request({
		url: '/timerPushConfig/listPushType',
		method: 'get',
	})
}

// 查询消息推送类型
export function searchTimePushConfigType() {
	return request({
		url: '/timerPushConfig/listMsgPushType',
		method: 'get',
	})
}

// 查看消息推送日志记录
export function searchTimePushRecord(params) {
	return request({
		url: '/timerPushConfig/pagePushRecord',
		method: 'get',
		params
	})
}

// 获取邮箱设置
export function getEmailInfo(params) {
	return request({
		url: '/sys/mail_config/getMailConfig',
		method: 'get',
		params
	})
}

// 设置邮箱
export function setEmailInfo(info) {
	return request({
		url: '/sys/mail_config/saveMailConfig',
		method: 'post',
		data:info
	})
}

// 导出配置
export function exportFormConfig(data) {
	return request({
		url: `/formConfig/export`,
		method: 'post',
		responseType: 'blob',
		data
	});
}

// 附件归集配置相关接口
export function getAllAttachmentConfigs() {
  return request({
    url: "/attachmentAggregationConfig/getAllConfigs",
    method: "get"
  });
}

export function addAttachmentConfig(data) {
  return request({
    url: "/attachmentAggregationConfig/add",
    method: "post",
    data
  });
}

export function updateAttachmentConfig(data) {
  return request({
    url: "/attachmentAggregationConfig/edit",
    method: "put",
    data
  });
}

export function deleteAttachmentConfig(ids) {
  return request({
    url: `/attachmentAggregationConfig/${ids}`,
    method: "delete"
  });
}

// 设置单元格颜色
export function setCellColor(data) {
  return request({
      url: "/list-field-colors/update",
      method: "post",
      data: data,
  });
}

// 获取单元格颜色
export function getCellColor(data) {
  return request({
      url: "/list-field-colors/findByFormConfigId",
      method: "get",
      params: data,
  });
}

// 删除单元格颜色
export function deleteCellColor(data) {
  return request({
      url: "/list-field-colors/delete",
      method: "post",
      data: data,
  });
}

// 一级表头配置
export function getFirstHeaderConfig(data) {
  return request({
    url: "/list-first-header-config/findByFormConfigId",
    method: "get",
    params: data,
  });
}

export function setFirstHeaderConfig(data) {
  return request({
    url: "/list-first-header-config/update",
    method: "post",
    data,
  });
}

export function deleteFirstHeaderConfigByForm(data) {
  return request({
    url: "/list-first-header-config/deleteByFormConfigId",
    method: "post",
    params: data,
  });
}
